<template>
  <div id="about" class="about jumbotron bg-white px-sm-1 px-lg-5">
      <div class="container">
        <div class="row px-sm-1 px-lg-5">
          <div class="col-12 text-center">
            <h1 class="mb-5">About Us</h1>
            <p v-html="content1"></p>
          </div>
          <div class="col-12 text-center">
            <p>{{content2}}</p>
          </div>
          <div class="col-12 text-center">
            <p>{{content3}}</p>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'About',
    mounted: {
      
    },
    data(){
        return {
            content1: `<strong><span style="color: #4091d8">PRO</span><span style="color: #c00000">gresso</span></strong>  is a group of professional developers thrilled for making our customers success’s our success. We simplify your business through our mobile, web and software solutions tailor made. Let us do the cooking!`,
            content2: `We strive for bringing solutions to our customers through our commitment, quality and professionalism. Our knowledge and out of the box thinking, our main ingredients.`,
            content3: `Through our technical capabilities and agile working methodologies, we perform a professional software analysis. We deliver quality products on time.`
        }
    }
}
</script>
